import { Component, OnInit, ElementRef ,OnDestroy } from '@angular/core';
import {  ViewChild } from '@angular/core';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';
import {Http, Response, Headers} from '@angular/http';

@Component({
  selector: 'app-fe-trafalgar-south-east-google-calendar',
  templateUrl: './fe-trafalgar-south-east-google-calendar.component.html',
  styleUrls: ['./fe-trafalgar-south-east-google-calendar.component.css']
})
export class FeTrafalgarSouthEastGoogleCalendarComponent implements OnInit {



  totalroomevents:RoomEvents[];
  roomevents_arena:RoomEvents[];
  roomevents_CommroomA:RoomEvents[];
  roomevents_CommroomB:RoomEvents[];
  roomevents_CommroomC:RoomEvents[];
  roomevents_Fitness:RoomEvents[];
  roomevents_ShooterPadA:RoomEvents[];
  roomevents_ShooterPadB:RoomEvents[];

  public event_array_arena:Event_array_arena[];
  public event_CommroomA:Event_array_room[];
  public event_CommroomB:Event_array_room[];
  public event_CommroomC:Event_array_room[];
  public event_Fitness:Event_array_room[];
  public event_ShooterPadA:Event_array_room[];
  public event_ShooterPadB:Event_array_room[];

  public Event_start_time:string[];
  public Event_end_time:string[];
  public Today_date:string;
  public Clock_date:string;

  public Event_room_name:string;
  
  public event_counter_arena:number;
  public event_counter_room:number;

  public currentTime: string;
  private timeUpdateInterval;

  constructor(private route: ActivatedRoute,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {
    setInterval(() => {
       this.refreshData();
    }, 20000);
  

    $("#slideshow > div:gt(0)").hide();

    setInterval(() => { 
      $('#slideshow > div:first')
        .fadeOut(1000)
        .next()
        .fadeIn(1000)
        .end()
        .appendTo('#slideshow');
    },  7000);

    this.timeUpdateInterval = setInterval(() => this.updateTime(), 1000);

   }
   ngOnDestroy() {
    clearInterval(this.timeUpdateInterval);  // Clear the interval when component is destroyed
  }

  ngOnInit() {
    this.event_counter_arena=0;
    this.event_counter_room=0;
    $("#slideshow > div:gt(0)").hide();
    this.updateTime();
    this.refreshData();
  }

  private updateTime() {
    const now = new Date();
    let hours = now.getHours();
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const amPM = hours >= 12 ? 'PM' : 'AM';

    // Convert 24-hour format to 12-hour format
    if (hours > 12) {
        hours = hours - 12;
    } else if (hours === 0) {
        hours = 12;
    }

    this.currentTime = `${hours.toString().padStart(2, '0')}:${minutes} ${amPM}`;
}


  format_time= (date_obj) => {
    // formats a javascript Date object into a 12h AM/PM time string
    var hour = date_obj.getHours();
    var minute = date_obj.getMinutes();
    var amPM = (hour > 11) ? "PM" : "AM";
    if(hour > 12) {
      hour -= 12;
    } else if(hour == 0) {
      hour = "12";
    }
    if(minute < 10) {
      minute = "0" + minute;
    }
    return hour + ":" + minute +" "+ amPM;
   }


   refreshData = ()=>{
    console.log("getting data")
     // let account_id = this.route.snapshot.paramMap.get('id');
     // console.log(account_id)
       ////Date////
       var d = new Date();
       var currentDate = d.getTime();
       d.setHours(0, 0, 0, 0);
       var currentDate_start = d.getTime();
       d.setHours(23, 59, 59, 999);
       var currentDate_end = d.getTime();
      console.log(currentDate);

       this.totalroomevents = [];

      //1 IRCC Facility
      this.getdataService.getGoogleCalendarData('oakvilleorl@gmail.com').subscribe((roomevents) => {
        console.log("IRCC Facility",roomevents)
      for(let i=0; i<roomevents.length ; i++){
        this.totalroomevents.push(roomevents[i])  ;
        }
       

         console.log(roomevents)
       // this.totalroomevents=  roomevents;
        this.roomevents_CommroomA = [];
        this.roomevents_CommroomB = [];
        this.roomevents_CommroomC = [];
        this.roomevents_Fitness = [];
        this.roomevents_ShooterPadA = [];
        this.roomevents_ShooterPadB = [];
        this.roomevents_arena = [];
        ////console.log(roomevents)
        var x=0;
        var y=0;
        var z=0;
        var c=0;
        var m=0;
        var t=0;
        var r=0;

        //separate arrays//
        
        for(let i=0; i<this.totalroomevents.length; i++)
        {
          let startDate = new Date(this.totalroomevents[i].start.dateTime).getTime();
          let endDate = new Date(this.totalroomevents[i].end.dateTime).getTime();
          if(startDate <= currentDate && endDate > currentDate) 
          {
           if(this.totalroomevents[i].organizer.displayName =='River Oaks Community room A')
           {
             console.log("added to Community Center - Room A")
            this.roomevents_CommroomA.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].organizer.displayName =='River Oaks Community room B'){
            console.log("added to Community Center - Room B")
            this.roomevents_CommroomB.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].organizer.displayName =='River Oaks Community room C'){
            console.log("added to Community Center - Room C")
            this.roomevents_CommroomC.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].organizer.displayName =='River Oaks Fitness'){
            console.log("added to Fitness Room")
            this.roomevents_Fitness.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].organizer.displayName =='River Oaks Rink A disabled'){
            console.log("added to Shooter Pad A")
            this.roomevents_ShooterPadA.push(this.totalroomevents[i]);
           }else if(this.totalroomevents[i].organizer.displayName =='River Oaks Rink B disabled'){
            console.log("added to Shooter Pad B")
            this.roomevents_ShooterPadB.push(this.totalroomevents[i]);
           }else{
            this.roomevents_arena.push(this.totalroomevents[i]);
           }
          }
        }
        
        this.event_array_arena=[];
        this.roomevents_arena = this.sortByKey(this.roomevents_arena,'start','dateTime');

        for(let i=this.event_counter_arena; i<this.roomevents_arena.length; i++)
         {
           let startDate = new Date(this.roomevents_arena[i].start.dateTime).getTime();
           let endDate = new Date(this.roomevents_arena[i].end.dateTime).getTime();

           if(startDate <= currentDate && endDate > currentDate) 
           {
    
             this.event_array_arena[x]={Event_id:x,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
             this.event_array_arena[x].Event_name=this.roomevents_arena[i].summary ;
             this.event_array_arena[x].Event_room=this.roomevents_arena[i].location;
              var  date = new Date(startDate);
             this.event_array_arena[x].Event_start_time=this.format_time(date).toString();
             this.event_array_arena[x].Event_start_time_number = startDate;
             date = new Date(endDate);
             this.event_array_arena[x].Event_end_time=this.format_time(date).toString() ;
             this.event_array_arena[x].Event_end_time_number = endDate;
             //this.roomevents_arena[i].organizer.displayName = this.roomevents_arena[i].organizer.displayName.replace('River Oaks','');
             
             this.event_array_arena[x].Event_Host_Name=this.roomevents_arena[i].organizer.displayName; 
             if (!this.roomevents_arena[i].organizer || !this.roomevents_arena[i].organizer.displayName) {
              // Handle the case where displayName is not present
              this.event_array_arena[x].Event_Host_Name="IRCC Facility"
            }
            
             x++;
            
           }
          
         }
        
          this.event_counter_arena=this.event_counter_arena+7;
         //console.log("counter ",this.event_counter_arena);
         //console.log("length ",this.roomevents_arena.length);
         if(this.event_counter_arena >= this.event_array_arena.length)
         {
          this.event_counter_arena=0;
         }



 
    },
    err=>{
      //////console.log(err);
      return false;
    });
    
   }


   sortByKey(array, key,subkey) {
    return array.sort(function(a, b) {
        var x = a[key][subkey]; var y = b[key][subkey];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

}



interface RoomEvents{
  _id:number,
  event_name:string,
  summary:string,
  organizer,
  start,
  end,
  location,
  event_room:string,
  event_room_id:string,
  event_place:string,
  event_start_time:Date,
  event_start_time_readable:string,
  event_end_time_readable:string,
  event_end_time:Date,
  event_logo:string,
  event_logo_path:string,
  event_host_name:string,
  event_attendants:string[]
}


interface Event_array_arena{
  Event_id:number,
  Event_name:string,
  Event_room:string,
  Event_start_time:string,
  Event_start_time_number:number,
  Event_end_time:string,
  Event_end_time_number:number,
  Event_Host_Name:string
}

interface Event_array_room{
  Event_id:number,
  Event_name:string,
  Event_room:string,
  Event_start_time:string,
  Event_start_time_number:number,
  Event_end_time:string,
  Event_end_time_number:number,
  Event_Host_Name:string
}



// WEBPACK FOOTER //
// ./src/app/components/fe-trafalgar-south-east-google-calendar/fe-trafalgar-south-east-google-calendar.component.ts